import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_promoBlock = _resolveComponent("promoBlock")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createBlock(_component_ion_grid, {
    style: _normalizeStyle(_ctx.backgroundStyle),
    class: "banner-grid",
    "data-cy": "promo-area"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_row, {
        class: _normalizeClass(_ctx.isPortraitOrientation ? 'stacked-content-blocks' : 'content-blocks')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_promoBlock, {
            promoBlock: _ctx.firstBlock,
            whichBlock: "firstBlock"
          }, null, 8, ["promoBlock"]),
          _createVNode(_component_promoBlock, {
            promoBlock: _ctx.secondBlock,
            whichBlock: "secondBlock"
          }, null, 8, ["promoBlock"])
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }, 8, ["style"]))
}